import React, { useRef } from "react";
import { useForm } from "react-hook-form";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid2";
import TextInput from "../../components/TextInput/TextInput.js";
import InvoiceController from "./Controller/invoice_controller.ts";
import { notification } from "antd";
import InfinityEncryptor from "../../components/EncryptDecrypt/InfinityEncryptor.js";
import CustomSeparator from "./../../layouts/AdminLayout/Header/Breadcrumbs.js";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Dashboard = () => {
  const fileInputRef = useRef(null); // Create a ref for the file input

  // notification
  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, desc, msg) => {
    api[type]({
      message: msg,
      description: desc,
    });
  };
  // encryptor
  const key = "12345";
  const mode = "YMDHI";
  const Encryptor = new InfinityEncryptor(key, mode);

  const {
    handleSubmit,
    register,
    formState: { errors },
    control,
    reset,
    setValue,
  } = useForm({
    defaultValues: {
      title: "",
      description: "",
    },
  });

  const onSubmit = async (data) => {
    console.log(data);
    const formData = new FormData();
    formData.append("title", Encryptor.Encrypt(data.title));
    formData.append("description", Encryptor.Encrypt(data.description));

    if (Object.keys(errors).length > 0) {
      console.log("Form has errors:", errors);
      return; // Prevent submission if there are errors
    }
    try {
      InvoiceController.createInvoiceNotes(formData).then((response) => {
        if (response?.status === "success") {
          reset();
          openNotificationWithIcon(
            "success",
            "Your data has been saved successfully!",
            "Success"
          );
        }
      });
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const onInvalid = (errors) => {
    console.log("Form has errors:", errors);
  };

  return (
    <Box
      sx={{
        display: "flex",
        backgroundColor: "#e8e8e8",
        height: "100%", // scroll y for page
        minHeight: "150vh",
        width: "100vw", // Full viewport width
        overflow: "hidden", // Ensure no overflow from the Box itself
      }}
    >
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <DrawerHeader />
        <CustomSeparator pageName="invoice_notes" />
        {contextHolder}

        <Typography gutterBottom variant="h4" sx={{ color: "text.secondary" }}>
          Create Invoice Notes
        </Typography>
        <form
          onSubmit={handleSubmit(onSubmit, onInvalid, {
            shouldFocusError: true,
          })}
        >
          <Grid container spacing={2} sx={{ p: 2 }}>
            <Grid size={4}>
              <label>Title</label>
            </Grid>
            <Grid size={8}>
              <TextInput
                type="text"
                {...register("title", {
                  required: "This field is required",
                })}
                onErrorCheck={errors.title ? errors.title.message : ""}
                control={control}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ p: 2 }}>
            <Grid size={4}>
              <label>Description</label>
            </Grid>
            <Grid size={8}>
              <TextInput
                type="text"
                {...register("description", {
                  required: "This field is required",
                })}
                onErrorCheck={
                  errors.description ? errors.description.message : ""
                }
                control={control}
              />
            </Grid>
          </Grid>

          <Box textAlign="center" sx={{ paddingBottom: "80px" }}>
            <Button
              sx={{
                borderRadius: "20px",
                mt: 4,
                mb: 4,
                // width: "93.4%",
                height: "48px",
                backgroundColor: "#d33333",
                position: "fixed", // Makes the button fixed
                bottom: "16px", // Position the button 16px from the bottom
                transform: "translateX(-50%)", // Aligns the button in the center
                zIndex: 1000, // Ensures the button stays on top of other elements
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)", // Floating shadow
                transition: "all 0.3s ease", // Smooth transition for hover effects

                "&:hover": {
                  backgroundColor: "#b02e2e", // Darker red on hover
                  boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.3)", // Larger shadow on hover
                  transform: "translate(-50%, -5px)", // Moves up slightly on hover
                },
              }}
              variant="contained"
              type="submit"
            >
              <Typography variant="h6">Save</Typography>
            </Button>
          </Box>
        </form>
      </Box>
    </Box>
  );
};

export default Dashboard;
